<div
  *ngIf="!showHighlightsTwo"
  class="content-layout" [brightsideWebFb]="{event_name: 'loan_highlights'}">
  <bw-action-article-legacy>
    <div header-actions>
      <ui-nav-exit-back
        [trackingDetail]="{ event_name: 'loan_highlights' }"
        [skipActionEmit]="true"
      ></ui-nav-exit-back>
    </div>
    <div pre-title>
      <img src="../assets/loan-calendar.png" width="134">
    </div>
    <div header-title>
      <typography-legacy title-large color="var(--primary-text)">
        {{ loanHightlightTitleOne | translate }}
      </typography-legacy>
    </div>
    <div content-section>
      <typography-legacy>
        <div [innerHTML]="loanHightlightDescOne | translate"></div>
      </typography-legacy>
    </div>
    <div footer-actions>
      <button
        bw-button-legacy
        [brightsideWebFb]="{event_name: 'loan_highlights'}"
        (click)="showHighlightsTwo = true">
        {{ 'BUTTON_CONTINUE' | translate }}
      </button>
    </div>

  </bw-action-article-legacy>
</div>
<div
  *ngIf="showHighlightsTwo"
  class="content-layout" [brightsideWebFb]="{event_name: 'loan_highlights_autosave'}">
  <bw-action-article-legacy>
    <div header-actions>
      <ui-nav-exit-back
        [trackingDetail]="{ event_name: 'loan_highlights_autosave' }"
        [skipActionEmit]="false"
        (exitActionHandler)="showHighlightsTwo = false"
      ></ui-nav-exit-back>
    </div>
    <div pre-title>
      <img src="../assets/loan-coin.png" width="134">
    </div>
    <div header-title>
      <typography-legacy title-large color="var(--primary-text)">
        {{ loanHightlightTitleTwo | translate }}
      </typography-legacy>
    </div>
    <div content-section>
      <typography-legacy>
        <div [innerHTML]="loanHightlightDescTwo | translate"></div>
      </typography-legacy>
    </div>
    <div footer-actions>
      <button
        bw-button-legacy
        [brightsideWebFb]="{event_name: 'loan_highlights_autosave'}"
        (click)="routeUser();">
        {{ 'BUTTON_CONTINUE' | translate }}
      </button>
    </div>

  </bw-action-article-legacy>
</div>
